import React from "react";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import PageRegularLink from "./LinkBlocks/Regular";
import PageSpotifyLink from "./LinkBlocks/Spotify";
import PageYoutubeVideo from "./LinkBlocks/YoutubeVideo";
import PageSoundcloudLink from "./LinkBlocks/SoundCloud";
import LogoFooterLinksight from "./LogoLinksight";
import PageTwitchChannel from "./LinkBlocks/Twitch";
import PageEmail from "./LinkBlocks/Email";
import PageBandcampAudio from "./LinkBlocks/BandcampAudio";
import PageDeezer from "./LinkBlocks/Deezer";
import IntegratedLargeThumbnail from "./LinkBlocks/IntegratedLargeThumbnail";
import ClassicSmallThumbnail from "./LinkBlocks/ClassicSmallThumbnail";
import ClassicLargeThumbnailPrev from "./LinkBlocks/ClassicThumbnailFull";
import SocialLinks from "./SocialLinks";
import DividerTitle from "./LinkBlocks/DividerTitle";

const Preview = ({ pageDetails, links }) => {
  return (
    <div className={`page-layout ${pageDetails.ThemeClass}`}>
      <div className="page-container">
        <div className="header-page">
          <div className="avatar-section">
            <Avatar
              size={100}
              src={pageDetails.PagePicture}
              icon={<UserOutlined />}
            />
          </div>
          <div className="title-section">
            {pageDetails.DisplayPageName ? (
              <div className="page-name">@{pageDetails.PageName}</div>
            ) : (
              ""
            )}
            {pageDetails.PageTitle && pageDetails.PageTitle.length > 0 ? (
              <div className="page-title">{pageDetails.PageTitle}</div>
            ) : (
              ""
            )}
            {pageDetails.PageDescription &&
            pageDetails.PageDescription.length > 0 ? (
              <div className="page-description">
                {pageDetails.PageDescription}
              </div>
            ) : (
              ""
            )}
          </div>
          {/* avatar section  */}
          {/* // Handle */}
        </div>
        {!pageDetails.SocialLinksBottom ? (
          <SocialLinks pageDetails={pageDetails} isPredefined={true} />
        ) : (
          ""
        )}
        <div className="page-links">
          {/* eslint-disable-next-line */}
          {links.map((link, index) => {
            if (link.LinkType === "regular" && link.IsActive) {
              return <PageRegularLink link={link} key={index} />;
            } else if (link.LinkType === "youtube-video" && link.IsActive) {
              return <PageYoutubeVideo link={link} key={index} />;
            } else if (link.LinkType === "youtube-sub") {
            } else if (link.LinkType === "spotify" && link.IsActive) {
              return <PageSpotifyLink link={link} key={index} />;
            } else if (link.LinkType === "soundcloud" && link.IsActive) {
              return <PageSoundcloudLink link={link} key={index} />;
            } else if (link.LinkType === "twitch-channel" && link.IsActive) {
              return <PageTwitchChannel link={link} key={index} />;
            } else if (link.LinkType === "email" && link.IsActive) {
              return <PageEmail link={link} key={index} />;
            } else if (link.LinkType === "bandcamp-audio" && link.IsActive) {
              return <PageBandcampAudio link={link} key={index} />;
            } else if (link.LinkType === "deezer" && link.IsActive) {
              return <PageDeezer link={link} key={index} />;
            } else if (link.LinkType === "thumbnail-full" && link.IsActive) {
              return <ClassicLargeThumbnailPrev link={link} key={index} />;
            } else if (
              link.LinkType === "thumbnail-integrated" &&
              link.IsActive
            ) {
              return <IntegratedLargeThumbnail link={link} key={index} />;
            } else if (
              link.LinkType === "thumbnail-thumbnail" &&
              link.IsActive
            ) {
              return <ClassicSmallThumbnail link={link} key={index} />;
            } else if (link.LinkType === "divider-title" && link.IsActive) {
              return <DividerTitle link={link} key={index} />;
            }
          })}
        </div>
        {pageDetails.SocialLinksBottom ? (
          <SocialLinks pageDetails={pageDetails} isPredefined={true} />
        ) : (
          ""
        )}
        {pageDetails.HasLogo ? (
          <div className="page-footer">
            <a
              href={`https://linksight.me/?utm_source=micropage&utm_campaign=${pageDetails.PageName}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LogoFooterLinksight
                themeFontColor={pageDetails.ThemeFontColor}
              />
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Preview;
